export enum WhoOptionsTrueFalse
{
    True = 1,
    False = 2
}

